export default __webpack_public_path__ + "static/media/footer4.92abb8f7.png";